module.exports = __webpack_public_path__ + "img/title.36aae39e.gif";